import { render } from "./ByCategory.vue?vue&type=template&id=529fe3f7"
import script from "./ByCategory.vue?vue&type=script&lang=js"
export * from "./ByCategory.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/gestx.ztech.ci/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__